// Javanese translations
export const jv: Record<string, string> = {
  'menu.dashboard': 'Dashboard',
  'menu.customers': 'Pelanggan',
  'menu.products': 'Produk',
  'menu.users': 'Pangguna',
  'menu.settings': 'Setelan',
  'menu.logout': 'Metu',
  'dashboard.title': 'Dashboard',
  'dashboard.newOrder': 'Pesenan Anyar',
  'order.title': 'Pesenan Anyar',
  'order.customer': 'Pelanggan',
  'order.products': 'Produk',
  'order.total': 'Total',
  'users.title': 'Pangguna',
  'users.name': 'Jeneng',
  'users.email': 'Email',
  'common.yes': 'Iya',
  'common.no': 'Ora',
  'common.cancel': 'Batal',
  'common.save': 'Simpen',
  'common.search': 'Goleki',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Mlebu',
  'login.welcome': 'Sugeng rawuh, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'Email',
  'signup.phone': 'Telpon',
  'menu.reportsAndAccounting': 'Laporan & Akuntansi',
  'menu.systemAndCommunication': 'Sistem & Komunikasi',
};